import { useState, useSyncExternalStore } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { authService } from '../../Services/AuthService';

export default function SessionExpiredDialog() {
  const open = useSyncExternalStore(authService.subscribe, authService.isSessionExpired);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const reconnect = async () => {
    setBusy(true);
    setError('');
    try {
      await authService.reauthenticate();
    } catch {
      setError('Innskráningu lauk ekki. Leyfðu sprettiglugga og skráðu þig inn með sama aðgangi og áður.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} disableEscapeKeyDown aria-labelledby="session-expired-title" maxWidth="sm" fullWidth>
      <DialogTitle id="session-expired-title">Skráðu þig inn aftur</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Innskráning er útrunnin. Opnar breytingar haldast hér á síðunni meðan þú skráir þig inn í sérglugga.
          Reyndu aftur að vista að innskráningu lokinni.
        </DialogContentText>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" disabled={busy} onClick={reconnect}>
          {busy ? 'Bíð eftir innskráningu…' : 'Skrá inn og halda áfram'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
